const normalizeAndParseNumbers = (text: string): string => {
  // Remove all commas (thousands separators) and replace commas for decimal separator with dot
  const cleanedText = text.replace(/,/g, '.');

  // Try to parse as a number (in case there are any non-numeric characters)
  const parsedValue = parseFloat(cleanedText);

  // If the value is a valid number, return it formatted as a string
  return !isNaN(parsedValue) ? parsedValue.toString() : '';
};

const sanitizePastedText = (text: string): string => {
  // Remove any HTML tags (in case something was copied from Excel/Google Sheets)
  const plainText = text.replace(/<\/?[^>]+(>|$)/g, '').trim();

  // Remove non-printing characters that might mess up the parsing (e.g., zero-width spaces)
  return plainText.replace(/\u200B/g, '');
};

export const processPastedData = (text: string): string[][] => {
  // This should remove all invalid data
  const sanitizedData = sanitizePastedText(text)
  
  // Split the text into rows (lines) based on newlines
  const rows = sanitizedData.split('\n');

  // Process each row into columns
  return rows
    .map(row => row.split('\t').map(cell => normalizeAndParseNumbers(cell)))
    .filter(row => row.every(cell => !isNaN(parseFloat(cell))));
};

export function genericHandlePaste(
  event: React.ClipboardEvent<HTMLInputElement>,
  currentIndex: number,
  columnHandlers: ((currentIndex: number, value: string[]) => void)[]
) {
  event.preventDefault();
  const pastedData = event.clipboardData.getData('text/plain');

  // Process the pasted data into rows and columns
  const processedData = processPastedData(pastedData);

  // Excel doesn't allow to copy irregular object (one column or one more row)
  const dataLength = processedData[0].length;

  columnHandlers.forEach((handler, index) => {
    if (index < dataLength) {
      const columnData = processedData.map(data => data[index]);

      handler(currentIndex, columnData);
    }
  });
}